import { getWhatsappTemplate ,addTemplateHttp, uploadWhatsappMediaHttp } from "../../../Http/Index"

export const uploadWhatsappMedia = async (file: File): Promise<string | null> => {
  try {
    const res = await uploadWhatsappMediaHttp(file)
    console.log('upload response:', res?.data)
    return res?.data?.data?.url || null
  } catch (err) {
    console.log(err)
    return null
  }
}




export const fetchBulkTemplate=async(page:number)=>{
      try{
       let res=await getWhatsappTemplate(page)
       
       return res?.data
      }catch(err){
        console.log(err)
      }
}

export const addTemplate=async(payload:any)=>{
  try{
    await addTemplateHttp(payload)
    return {status:true,msg:"Successfully Added"}
    

  }catch (err: any) {
   
    const errorMsg = err.response?.data?.message || err.message || "Something went wrong";

    return { status: false, msg: errorMsg };
  }

}